var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"to":'/admin/' + _vm.table + '/edit/' + _vm.id}},[_vm._v("Edit ")]),_vm._v("   "),_c('router-link',{staticClass:"btn btn-danger btn-sm",attrs:{"to":'/admin/' + _vm.table + '/delete/' + _vm.id}},[_vm._v("Delete ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }